// Status codes for Laravel API (string-based)
export const OK = 'OK';
export const INCOMPLETE = 'INCOMPLETE';
export const UNFINISHED = 'UNFINISHED';
export const QUOTA_EXCEEDED = 'QUOTA_EXCEEDED';
export const ACCOUNT_EXPIRED = 'ACCOUNT_EXPIRED';
export const FORBIDDEN = 'FORBIDDEN';
export const INTERNAL_ERROR = 'INTERNAL_ERROR';
export const INVALID_ACCESS_TOKEN = 'INVALID_ACCESS_TOKEN';
export const THRESHOLD_EXCEEDED = 'THRESHOLD_EXCEEDED';
export const INVALID_ACTION = 'INVALID_ACTION';
export const INVALID_DATA = 'INVALID_DATA';
export const MAINTENANCE_MODE = 'MAINTENANCE_MODE';
export const NOT_ENOUGH_DATA = 'NOT_ENOUGH_DATA';
export const NOT_FOUND = 'NOT_FOUND';
export const PASSWORD_RESET_REQUIRED = 'password_reset_required';

// Legacy numeric status code (for backward compatibility)
export const LEGACY_OK = 10;

/**
 * Check if API response indicates success
 * Works with both legacy (status: 10) and new Laravel (status: 'OK' or 200) responses
 * @param {Object} resp - API response object
 * @returns {boolean} - true if response indicates success
 */
export const isApiSuccess = resp => {
  if (!resp) return false;
  return resp.status === LEGACY_OK || resp.status === OK || resp.status === 200;
};
